import { render } from "./ViewComposition.vue?vue&type=template&id=fd5276fe&scoped=true&ts=true"
import script from "./ViewComposition.vue?vue&type=script&lang=ts"
export * from "./ViewComposition.vue?vue&type=script&lang=ts"

import "./ViewComposition.vue?vue&type=style&index=0&id=fd5276fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5276fe"]])

export default __exports__